import { Injectable } from '@angular/core'

import { Store } from '@ngrx/store'

import { INotificationMessage } from '~/core/models'

import * as UI_ACTIONS from './ui.actions'
import { selectInRequest, selectNotifications, selectUiLanguage, selectUiThemeMode } from './ui.selectors'
import { IAppWithUiState } from './ui.state'

@Injectable()
export class UiFacade {
  isDarkTheme$ = this.store$.select(selectUiThemeMode)
  inRequest$ = this.store$.select(selectInRequest)
  language$ = this.store$.select(selectUiLanguage)
  notifications$ = this.store$.select(selectNotifications)

  constructor(private store$: Store<IAppWithUiState>) {}

  init(): void {
    this.store$.dispatch(UI_ACTIONS.initUi())
  }

  changeThemeMode(isDarkTheme: boolean): void {
    this.store$.dispatch(UI_ACTIONS.changeThemeMode({ isDarkTheme }))
  }

  changeLanguage(): void {
    this.store$.dispatch(UI_ACTIONS.changeLanguage())
  }

  startRequest(): void {
    this.store$.dispatch(UI_ACTIONS.startRequest())
  }

  endRequest(): void {
    this.store$.dispatch(UI_ACTIONS.endRequest())
  }

  // addNotification(snackBarData: ISnackBar): void {
  //   this.store$.dispatch(UI_ACTIONS.addNotification({ snackBarData }))
  // }

  // addErrorNotification(messageI18n: string, messageKeyI18n: { [key: string]: string } = {}): void {
  //   this.store$.dispatch(UI_ACTIONS.addErrorNotification({ messageI18n, messageKeyI18n }))
  // }

  // addInfoNotification(messageI18n: string, messageKeyI18n: { [key: string]: string } = {}): void {
  //   this.store$.dispatch(UI_ACTIONS.addInfoNotification({ messageI18n, messageKeyI18n }))
  // }

  // Notifications

  addNotification(notification: INotificationMessage): void {
    this.store$.dispatch(UI_ACTIONS.addNotification({ notification }))
  }

  removeNotification(index: number): void {
    this.store$.dispatch(UI_ACTIONS.removeNotification({ index }))
  }

  clearNotifications(): void {
    this.store$.dispatch(UI_ACTIONS.clearNotifications())
  }

  addSuccessNotification({
    i18nMessage = 'notificationPopup.success.successMessage',
    i18nTitle = 'notificationPopup.success.label',
  } = {}): void {
    this.store$.dispatch(UI_ACTIONS.addSuccessNotification({ i18nTitle, i18nMessage }))
  }

  addErrorNotification({
    i18nMessage = 'notificationPopup.error.defaultMessage',
    i18nTitle = 'notificationPopup.error.label',
    error = null as any,
  } = {}): void {
    const finalMessage = error?.error?.error?.validationErrors?.[0]?.message || i18nMessage
    this.store$.dispatch(UI_ACTIONS.addErrorNotification({ i18nTitle, i18nMessage: finalMessage }))
  }
}
